var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokFooterCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "url(#paint0_linear_9393_564)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1429 22.8571H22.8571V27.1429C22.8571 27.3702 22.7668 27.5882 22.6061 27.7489C22.4453 27.9097 22.2273 28 22 28C21.7727 28 21.5547 27.9097 21.3939 27.7489C21.2332 27.5882 21.1429 27.3702 21.1429 27.1429V22.8571H16.8571C16.6298 22.8571 16.4118 22.7668 16.2511 22.6061C16.0903 22.4453 16 22.2273 16 22C16 21.7727 16.0903 21.5547 16.2511 21.3939C16.4118 21.2332 16.6298 21.1429 16.8571 21.1429H21.1429V16.8571C21.1429 16.6298 21.2332 16.4118 21.3939 16.2511C21.5547 16.0903 21.7727 16 22 16C22.2273 16 22.4453 16.0903 22.6061 16.2511C22.7668 16.4118 22.8571 16.6298 22.8571 16.8571V21.1429H27.1429C27.3702 21.1429 27.5882 21.2332 27.7489 21.3939C27.9097 21.5547 28 21.7727 28 22C28 22.2273 27.9097 22.4453 27.7489 22.6061C27.5882 22.7668 27.3702 22.8571 27.1429 22.8571Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9393_564",
    x1: 26.8116,
    y1: 43.9998,
    x2: 26.6448,
    y2: 0.000159118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.490509,
    stopColor: "#FECA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECA1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokFooterCreate);
export default __webpack_public_path__ + "static/media/tiktok_footer_create.2438ae6ebd1f6d504a651db5bb593434.svg";
export { ForwardRef as ReactComponent };